import { Button } from '@shadcn/ui/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shadcn/ui/components/ui/tooltip';
import { cn } from '@shadcn/ui/lib/utils';
import { Sparkles } from 'lucide-react';
import { FC } from 'react';
import { useAuth } from '../../providers/authentication-provider';

interface QuickClassificationButtonProps {
    contactId: string;
    openClassificationDialogForContact: (contactId: string) => void;
    onClassification?: (e: React.MouseEvent) => void;
    variant?: 'default' | 'ghost' | 'outline';
    size?: 'sm' | 'icon-sm' | 'icon';
    className?: string;
    showLabel?: boolean;
}

export const QuickClassificationButton: FC<QuickClassificationButtonProps> = ({
    contactId,
    openClassificationDialogForContact,
    onClassification,
    variant = 'ghost',
    size = 'icon-sm',
    className,
    showLabel = false,
}) => {
    const {
        authState: { isGlobalAdmin },
    } = useAuth();

    const handleClassification = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClassification?.(e);
        openClassificationDialogForContact(contactId);
    };

    // Only show for global admins or in dev mode
    if (!isGlobalAdmin && !import.meta.env.DEV) {
        return null;
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button variant={variant} size={size} onClick={handleClassification} className={cn(className)}>
                    <Sparkles
                        className={cn(
                            'h-4 w-4 flex-shrink-0',
                            variant === 'outline' ? 'text-current' : 'text-gray-500'
                        )}
                    />
                    {showLabel && <span className="hidden lg:inline">Classification</span>}
                </Button>
            </TooltipTrigger>
            <TooltipContent>
                <p>View classification (Admin)</p>
            </TooltipContent>
        </Tooltip>
    );
};
